export const enum AgendaLayout {
  Calendar = "calendar",
  List = "list",
}
